import React, { useEffect, useState } from 'react'
import ImgCard from '../components/pageStructure/ImgCard'
import axios from 'axios';


const BoardOfStudies = () => {
  const [data,setData] = useState();

  const getData = async ()=>{
    try {
      const url = process.env.REACT_APP_API+"/viewweb/view_web_studies";
      const res = await axios.get(url);
      console.log(res.data)
      setData(res?.data?.data)
    } catch (error) {
      console.log(error)
    }
  }
  useEffect(()=>{
    getData();
  },[])
  return (
    <div><ImgCard title={"Board Of Studies"} members={data} /></div>
  )
}

export default BoardOfStudies